
define('text!templates/modules/calendar/animated-session/exercise/weight/week-brief/weight-brief-header.html',[],function () { return '<tr>\n    <th class="reps-col">\n        <span data-bind="text:translate(repsType)"></span>\n    </th>\n    <th class="load-col">{{#t}}calendar:Load{{/t}}</th>\n    <th class="rest-col">{{#t}}questionnaire:Rest{{/t}}</th>\n</tr>\n';});

